// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3Thr5","modalForm":"UpgradeEpcsModal_modalForm__35M6b","modalFooter":"UpgradeEpcsModal_modalFooter__31jm7"};